import type {JSX} from 'react'
import {useFormContext} from 'react-hook-form'
import {clsx} from 'clsx'
import {logError} from '@/_new-code/services/logger/client'
import {ErrorMessage} from '../form'

interface ChoiceFieldProps {
	type: string
	label: string
	name: string
	id: string
	value: string
	className?: string
	isOptional?: boolean
	requiredErrorMsg?: string
	checked?: boolean
	onChange?: (value: string) => void
	disabled?: boolean
	isGroup: boolean
}

export const ChoiceField = ({
	className = '',
	checked = false,
	type,
	label,
	name,
	id,
	value,
	isOptional = false,
	requiredErrorMsg = '',
	isGroup,
	onChange,
	disabled = false,
}: ChoiceFieldProps): JSX.Element => {
	const requiredMsg = requiredErrorMsg || `${label} is required`
	const {register, formState} = useFormContext()
	const {onChange: libOnChange, ...registerProps} = register(name, {
		required: !isOptional,
	})

	return (
		<div className={clsx(isGroup ? 'my-1' : 'mb-4', 'relative', className)}>
			<input
				{...registerProps}
				className={clsx(
					formState.errors[name] ? 'invalid' : '',
					'hover:!bg-white'
				)}
				defaultChecked={checked}
				disabled={disabled}
				id={id}
				name={name}
				onChange={(e) => {
					libOnChange(e).catch((error) => {
						logError(`ChoiceField Error in libOnChange:${error}`)
					})
					onChange?.(e.target.value)
				}}
				type={type}
				value={value}
			/>
			<label
				className="w-full !text-sm text-pet-primary before:!border before:!border-light-grey after:!left-[9px] after:!top-[9px] after:!h-[14px] after:!w-[14px] after:!bg-pet-green"
				htmlFor={id}
				style={{marginTop: '0', marginBottom: '0'}}
			>
				<span>
					{isGroup || isOptional ? (
						label
					) : (
						<>
							{label}
							<span className="text-red-600">*</span>
						</>
					)}
				</span>
			</label>
			{!isGroup && formState.errors[name] ? (
				<ErrorMessage message={requiredMsg} />
			) : null}
		</div>
	)
}
